// ISO 3166-1 region from the cached settings (written by use-settings), used to
// localize TMDB release windows (now playing / upcoming). Defaults to US.
export const getRegion = (): string => {
  try {
    const cached = localStorage.getItem('settings-cache')
    if (!cached) return 'US'
    const settings = JSON.parse(cached)
    return settings?.region || 'US'
  } catch {
    return 'US'
  }
}
